<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">状态</div>
          <div class="field">
            <el-select v-model="query.status" :clearable="true" placeholder="请选择">
              <el-option
                v-for="item in projectStatusList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true"
            :total="query.total" @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'pgsIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        projectStatusList: [],
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          { field: 'projectstatusname', fieldtype: 'C', title: '状态',calculExpr:'',addNewRowFlg: false},
          // { field: 'projectdesc', fieldtype: 'C', title: '采购内容',calculExpr:'',addNewRowFlg: false},
          { field: 'projecttime', fieldtype: 'T', title: '建项时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', 'yyyy-MM-dd'], width: 100}
        ],
        project: {},
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('CONFIRM', () => this.setPgs())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
      this.getProjectStatusList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async getProjectStatusList () {
        this.projectStatusList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectstatus'}
        })
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          cosid: this.$store.getters.loginUser.cosid,
          userid: this.$store.getters.loginUser.userid,
          comid: this.$store.getters.loginUser.comid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.project = {}
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async setPgs() {
        if (!this.project.projectid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        // if (+this.project.projectstatus > 40) {
        //   this.$message.warning(`项目已进入${this.project.projectstatusname}不能做评分确认!`)
        //   return
        // }
        this.$router.push({name: 'pgsForm', params: {form: this.project, type: 1}})
      },
      async cellClick (row) {
        this.project = row.row
      },
      async viewProject(row) {
        this.project = row.row
        this.$router.push({name: 'pgsForm', params: {form: this.project, type: 1}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        console.log(this.query)
        this.loading = true
        this.query.projectstatus=30
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPageList',
          params: this.query
        })
        console.log(res)
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
